import moment from 'moment';

const getCurrentSeason = () => {
    return (moment().diff(moment(`01/08/${moment().format("YYYY")}`, "DD/MM/YYYY")) < 0 ? moment().format("YYYY") : Number(moment().format("YYYY")) + 1)
}

export { getCurrentSeason }